export default url => async () => {
  const request = await fetch(url);
  const response = await request.json();
  return response;
};
